module.exports = __webpack_public_path__ + "static/media/3.841c3738.jpg";